import { Injectable } from '@angular/core';
import { Analytics, getAnalytics, logEvent } from '@angular/fire/analytics';
// import { AngularFireAnalytics } from '@angular/fire/analytics';
// import { title } from 'process';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  public readonly LOGIN = "login";
  public readonly PAGE_VIEW = "page_view";
  public readonly SELECT_CONTENT = "select_content";
  private analytics: any;

  private LoginTemplate = {
    method: ""
  };
  private PageViewTemplate = {
    page_location: "",
    page_title: "",
    page_encoding: "UTF-8",
    user_agent: "",
    client_id: "",
    language: "en_us"
  };
  private SelectContentTemplate = {
    content_type: "",
    item_id: ""
  }

  private template: Object = {};
  private templateLogin: Object = {};

  
  constructor() { 
    (this.template as any)[this.LOGIN] = this.LoginTemplate;
    (this.template as any)[this.PAGE_VIEW] = this.PageViewTemplate;
    (this.template as any)[this.SELECT_CONTENT] = this.SelectContentTemplate; 
    this.analytics = getAnalytics();
  }

  setCurrentScreen(name: string) {
    // this.analytics.app..setCurrentScreen(name);
    logEvent(this.analytics, 'screen_view', {
      firebase_screen: name,
      firebase_screen_class: name
    });
    
  }

  logEvent(eventName: any, params?: Object) {
    // this.analytics.logEvent(eventName, params);

  }

  getTemplate(type: string): Object {
    return (this.template as any)[type];
  }

  buildPageViewParams(url: string, title?: string, user_agent?: string, language?: string, client_id?: string, encoding?: string){
    let pgTmpl = this.PageViewTemplate;
    pgTmpl.page_location = url;
    pgTmpl.page_title = title || pgTmpl.page_title;
    pgTmpl.page_encoding = encoding || pgTmpl.page_encoding;
    pgTmpl.user_agent = user_agent || pgTmpl.user_agent;
    pgTmpl.client_id = client_id || pgTmpl.client_id;
    pgTmpl.language = language || pgTmpl.language;

    return pgTmpl
  }

  buildPageSelectContentParams(content_type: any, item_id: any) {
    let scTmpl = this.SelectContentTemplate;
    scTmpl.content_type = content_type;
    scTmpl.item_id = item_id;

    return scTmpl;
  }


}